export const WAREHOUSES_PERMISSIONS = {
  SHOW_DATA: 'show_warehouses',
  CREATE_DATA: 'create_warehouses',
  EDIT_DATA: 'edit_warehouses',
  CHANGE_STATE_DATA: 'change_state_warehouses',
  DELETE_DATA: 'delete_warehouses',
  EXPORT_EXCEL: 'export_warehouses',
  IMPORT_EXCEL: 'import_warehouses',
} as const;
export const WAREHOUSES_PERMISSION_LIST = [
  WAREHOUSES_PERMISSIONS.SHOW_DATA,
  WAREHOUSES_PERMISSIONS.CREATE_DATA,
  WAREHOUSES_PERMISSIONS.EDIT_DATA,
  WAREHOUSES_PERMISSIONS.CHANGE_STATE_DATA,
  WAREHOUSES_PERMISSIONS.DELETE_DATA,
  WAREHOUSES_PERMISSIONS.EXPORT_EXCEL,
  WAREHOUSES_PERMISSIONS.IMPORT_EXCEL,
] as const;
